import About from "./component/about";
import Contect from "./component/contect";
import Navbar from "./component/Nav";
import Profile from "./component/profile";
import Project from "./component/project";
import Skill from "./component/skill";
import Aos from "aos"
import "aos/dist/aos.css"
import { useEffect } from "react";
import Git from "./component/git";

export default function Home(){
    useEffect(()=>{
        Aos.init({
            duration: 1200,offset:200
          })
          
          
    },[])
    return (
        <div>
        <div className="Nav_major" ><Navbar/></div>
    
        <div className="body">
        <div id="home"><Profile/></div>
        <div id="about" data-aos="fade-zoom-in"  data-aos-duration="1500"><About/></div>
        <div id="project" data-aos="fade-zoom-in"  data-aos-duration="1500"><Project/></div>
        <div id="skill"  data-aos="fade-zoom-in"  data-aos-duration="1500"><Skill/></div>
        <div><Git/></div>
        <div id="contect" data-aos="fade-zoom-in"   data-aos-duration="1500"><Contect/></div>
        </div>
        </div>
    )
}